/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class MembershipApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get membership cancellation reasons
     */
    public getCancellationReasons(__unused?: any): Observable<PagedArray<models.ApiCancellationReason>> {
        const path = '/membership/cancel/reasons';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiCancellationReason>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * 
     * @param id 
     * @param step 
     */
    public getMembershipOfferSetsIdStepImpression(id?: number, step?: number, __unused?: any): Observable<{}> {
        const path = '/membership/offer_sets/{id}/{step}/impression'
                    .replace('{' + 'id' + '}', String(id))
                    .replace('{' + 'step' + '}', String(step));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<any>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
